import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { FontSizes, FontWeights } from '../../../types/common/types';

export const templateXdrSearchTab = document.createElement('template');

templateXdrSearchTab.innerHTML = `
  <style>${commonStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${styles}</style>
  <header class='page__header'>
      <gz-title class="title" fontWeight="${FontWeights.MEDIUM}" fontSize="${FontSizes.TITLE}"></gz-title>
  </header>
  <gz-tab-group class='search-app-tab-group' id='search-app-tab-group'>
      <gz-tab id='historical-tab'>
        <gz-xdr-search-app istab></gz-xdr-search-app>
      </gz-tab>
      <gz-tab id='live-tab'>
        <gz-xdr-search-live></gz-xdr-search-live>
      </gz-tab>
  </gz-tab-group>
  <gz-side-menu resizable="left" menuwidth="400" closeOnClickOutside></gz-side-menu>
  <div id="sideMenuSettingsContainer"></div>
`;
